import _ from "lodash";

/**
 * List of allowed domains/origins for redirect URLs
 * Note: Domains have leading dots to correctly match subdomains with _.endsWith()
 */
const ALLOWED_REDIRECT_DOMAINS_OR_ORIGINS = [".toddleapp.com", ".toddleapp.cn"];

/**
 * Validates if a URL is safe for redirection
 * @param {string} url The URL to validate
 * @returns {boolean} True if URL is safe for redirection, false otherwise
 */
export const isRedirectUrlSafe = url => {
  try {
    // Ensure the URL is a non-empty string
    if (!_.isString(url) || !url.trim()) {
      return false;
    }

    const parsedUrl = new URL(url);
    const { hostname, origin, protocol } = parsedUrl;

    // Only allow HTTPS protocols
    if (protocol !== "https:") {
      return false;
    }

    return _.some(ALLOWED_REDIRECT_DOMAINS_OR_ORIGINS, allowedRecord => {
      try {
        // If the allowedRecord is a full URL, check its origin
        if (_.startsWith(allowedRecord, "https://")) {
          const allowedUrl = new URL(allowedRecord);
          return allowedUrl.origin === origin;
        }

        // If the allowedRecord is just a domain, check if the hostname ends with it
        return _.endsWith(hostname, allowedRecord);
      } catch (e) {
        return false;
      }
    });
  } catch {
    return false;
  }
};
